module.exports = __webpack_public_path__ + "img/2025big26.e3aba368.jpg";